<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-2" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i> Export</b-button
          >
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label style="min-width:120px;">Nama Debitur</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.debtorFullName"
              placeholder=""
            ></b-form-input>
            <b-input-group-append>
              <label class="ml-1 mr-1" style="min-width:120px;">Customer Id</label>
            </b-input-group-append>
            <b-form-input
              v-model="tblData.customerID"
              placeholder=""
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="min-width:120px;">Nama Collector</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.debtorFullName"
              placeholder=""
            ></b-form-input>
            <b-input-group-append>
              <label style="min-width:120px;" class="ml-1 mr-1">Manager</label>
            </b-input-group-append>
            <b-form-input
              v-model="tblData.customerID"
              placeholder=""
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <label style="min-width:120px;">Period</label>
              <b-form-input
              v-model="tblData.startdate"
              placeholder=""
              type="date"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text>-</b-input-group-text>
            </b-input-group-append>
            <b-form-input
              v-model="tblData.enddate"
              placeholder=""
              type="date"
            ></b-form-input>
            </b-input-group-prepend>
          </b-input-group>
          <b-input-group>
            <b-button class="btn btn-success ml-3" @click="refresh()">
              <i class="fa fa-refresh"></i> Apply
            </b-button>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
        :busy="isBusy"
      >
        <template v-slot:cell(index)="data">{{
          (tblData.page - 1) * tblData.limit + (data.index + 1)
        }}</template>
        <template v-slot:cell(disbursement_amount)="data">{{
          data.item.disbursement_amount | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(principal_repayment)="data">{{
          data.item.principal_repayment | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(principal_outstanding)="data">{{
          data.item.principal_outstanding | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(installmentEndDate)="data">{{
          data.item.installmentEndDate | moment("YYYY-MM-DD")
        }}</template>
        <template v-slot:cell(createdat)="data">{{
          data.item.createdat | moment("YYYY-MM-DD HH:mm")
        }}</template>

        <template v-slot:cell(period)="data">
          {{
          data.item.startdate | moment("YYYY-MM-DD")
        }}
          - 
          {{
          data.item.enddate | moment("YYYY-MM-DD")
        }}
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="showDelConfirm"
      title="Delete Record?"
      :centered="true"
      @ok="deleteData"
    >
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
    
  <script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import collection from "../../apis/collection";
toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isLoading: false,
      isBusy: false,
      showDelConfirm: false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "createdat",
        sortDesc: false,
        customQuery: "",
        debtorFullName: "",
        address: "",
        customerID: "",
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "customerID",
          label: "Customer ID",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "debtorFullName",
          label: "FullName",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "loan_id",
          label: "Loan ID",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "installmentEndDate",
          label: "Due Date",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "disbursement_amount",
          label: "Disbursement Amt.",
          thClass: "text-center",
          thStyle: "min-width:100px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "principal_repayment",
          label: "Principal Repayment",
          thClass: "text-center",
          thStyle: "min-width:100px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "principal_outstanding",
          label: "Principal OS",
          thClass: "text-center",
          thStyle: "min-width:100px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "dpd",
          label: "DPD",
          thClass: "text-center",
          thStyle: "min-width:100px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "collector_name",
          label: "Collector",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "period",
          label: "Period",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "note",
          label: "Note",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "createdby",
          label: "Created By",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "createdat",
          label: "Created At",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        }
      ];
      return fields;
    },
  },
  methods: {
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      // }
    },
    async edit(model) {
      if (model.borrowerKey && model.borrowerKey !== "undefined") {
        const filter = this.$store.state.filter;
        this.$store.commit("filter", filter);
        router.push({
          name: "master.borrowerform",
          params: { borrowerKey: model.borrowerKey },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    add: function () {
      router.push({ name: "collection.assignmentform" });
    },
    deleteConfirm(item) {
      this.rowClicked(item);
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      try {
        await crud.remove({
          tablename: this.tblData.tablename,
          key: this.model.borrowerKey,
        });
        this.refresh();
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const list = await collection.assignment(this.tblData);
        this.isBusy = false;
        console.log("list", list);
        return list;
      } catch (error) {
        this.isBusy = true;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await crud.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    // async importxls() {
    //   router.push({ name :'loan.importdatadebitur' });
    // },
    async importCollectorToDebiturXls() {
      router.push({ name: "loan.importDataCollectorToDebitur" });
    },

    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "customerID",
        sortDesc: false,
        tablename: "borrowercrud",
        customQuery: "",
        debtorFullName: "",
        address: "",
        customerID: "",
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    },
  },
};
</script>